<template>
  <a-modal v-model="visible" :footer="null" :maskClosable="false" class="payment-result-contenter" :afterClose="close" :destroyOnClose="true" key="loginFrm" :width="350">
    <div class="title">
      支付信息
    </div>
    <div class="content">
      <p class="congratulation">
        恭喜, 支付成功!
      </p>
      <p class="countdown">
        {{countdown}}秒后进入会员中心首页
      </p>
      <p class="link">
        <a href="/emailfinder/" style="margin-right: 30px;">关键人定位
          <a-icon type="caret-right" style="transform: scale(0.7);margin-left: -5px;" /></a>
        <a href="/buyerfinder/">采购商数据查询
          <a-icon type="caret-right" style="transform: scale(0.7);margin-left: -5px;" /></a>

      </p>
    </div>
  </a-modal>
</template>
<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";

export default {
  components: {
    "s-qrcode": VueQrcode
  },
  data() {
    return {
      visible: true,
      countdown: 3
    };
  },
  props: {
    close: Function
  },
  mounted() {
    var i = setInterval(() => {
      this.countdown -= 1;
      if (this.countdown < 1) {
        this.close();
        clearInterval(i);
      }
    }, 1000);
  }
};
</script>
<style lang="scss" scope>
@import "~@/components/layout/style/mixin.scss";
.payment-result-contenter {
  .ant-modal-body {
    padding: 0;
  }
  .title {
    width: 100%;
    height: 60px;
    padding: 10px 20px;
    font-size: 16px;
    line-height: 40px;
    background-color: #f3f3f3;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .content {
    text-align: center;
    .congratulation {
      font-size: 26px;
      color: #3ab006;
      margin: 25px 0 10px 0;
    }
    .countdown {
      margin: 0 0 30px 0;
      font-size: 13px;
      color: #999;
    }
    .footer {
      height: 70px;
      border-top: 1px solid #eee;
      background-color: #f6fcff;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      text-align: right;
      button {
        border-radius: 0px;
        width: 135px;
        height: 36px;
        margin-top: 15px;
        margin-right: 20px;
        font-size: 16px;
      }
    }
  }
}
</style>
